import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import React from 'react';
import { T } from '../../../../../Translations';
import InternalName from './InternalName';

interface Props {
  children: React.ReactNode;
}

function HeaderView({ children }: Props) {
  return (
    <div className="flex justify-between bg-white px-10 pt-4 w-full border-b mb-px">
      <div className="flex flex-col w-1/2">
        <div className="flex items-center mb-1">
          <Typography variant="subtitleLarge" fontWeight="semibold">
            <T kind="Create a collection with EXO AI" />
          </Typography>
        </div>
        <InternalName />
      </div>
      {children}
    </div>
  );
}

export default observer(HeaderView);
